/* eslint-disable react-hooks/rules-of-hooks */
import { sleepTimer } from "../constants/data-constants";
import { logOut, setIdleModal } from "../redux/user/user.actions";
import { store } from "../redux/store";

class InactivityClass {
  // idle logout timer set to 15 minutes
  public idleLogoutTimer: any;
  public idleAlertModalTimer: any;
  public titleInterval: any;

  // First execute the timer and wait for hostListener
  onInit = () => {
    // this.restartIdleLogoutTimer();
  };

  // Whenever users touch action occure this function will execute.
  onTouchStart = () => {
    // this.restartIdleLogoutTimer();
  };

  // First this will clear timeout then again setTimeout fun and counting start again, After specific time if user did not active then log out function will execute.
  restartIdleLogoutTimer() {
    clearInterval(this.titleInterval);
    clearTimeout(this.idleLogoutTimer);
    clearTimeout(this.idleAlertModalTimer);
    store.dispatch(setIdleModal(false));
    document.title = "TN - Trader";
    const alertTimer = sleepTimer - sleepTimer / 6;
    this.idleAlertModalTimer = setTimeout(() => {
      store.dispatch(setIdleModal(true));
      document.title = "Session Timeout !!!";
      this.titleInterval = setInterval(() => {
        if (document.title === "Session Timeout !!!") {
          document.title = "Alert !!!";
        } else {
          document.title = "Session Timeout !!!";
        }
      }, 750);
    }, alertTimer);
    this.idleLogoutTimer = setTimeout(() => {
      this.stopTimers();
      document.title = "Session Timedout !!!";
      store.dispatch(logOut());
    }, sleepTimer);
  }

  stopTimers = () => {
    store.dispatch(setIdleModal(false));
    clearInterval(this.titleInterval);
    clearTimeout(this.idleLogoutTimer);
    clearTimeout(this.idleAlertModalTimer);
    this.titleInterval = null;
    this.idleLogoutTimer = null;
    this.idleAlertModalTimer = null;
  };

  consentLogoutUser = () => {
    document.title = "TN - Trader";
    store.dispatch(logOut());
  };
}

const triggerSleepClient = new InactivityClass();
export default triggerSleepClient;
